import React from 'react';
import NoDataRow from "../../../../../components/reports/no-data-row.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const BoContent = ({ garrison, boName, showDetails }) => {
    const navigate = navigateHook();
    if (!showDetails) return null;
    const data = garrison?.boData;

    return (
        <tr>
            <td colSpan={12} style={{ padding: 0 }}>
                <table className="w-full my-4">
                    <thead>
                        <tr>
                            <th colSpan={7} className="headerTitle text-zinc-600">
                                {boName} do plantão
                                <span className="xRayPath">
                                    <a onClick={() => ReportUtils.openXRay(navigate, 'bo_x_ray', garrison)}>Acessar Raio X de {boName}</a>
                                </span>
                            </th>
                        </tr>

                        <tr className={'divisor-header text-zinc-600'}>
                            <th className={'w-[5%]'}>Despacho</th>
                            <th className={'w-[10%]'}>Nº {boName}</th>
                            <th className={'w-[15%]'}>Natureza</th>
                            <th className={'w-[15%]'}>Bairro</th>
                            <th className={'w-[10%]'}>Marcadores</th>
                            <th className={'w-[40%]'}>Resumo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {!data?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : data.map((bo, index) => {
                            const urlDispatch = `/despacho/dispatch/form/${bo?.dispatch_id}`;
                            const urlBO = `/bo/redirect/${bo?.bogcmid?.replace('/', '-')}`;
                            const tags = bo?.tags ?? [];

                            return (
                                <tr key={index} style={{borderBottom: '1px solid #e7eaec'}}>
                                    <td className={'w-[5%]'}>{bo?.numbercheckbook ? <p onClick={() => navigate(urlDispatch, true)} className={'inner-link'}>{bo?.numbercheckbook}</p> : 'Sem talão'}</td>
                                    <td className={'w-[10%]'}>{bo?.bogcmid ? <p onClick={() => navigate(urlBO, true)} className={'inner-link'}>{bo?.bogcmid}</p> : ''}</td>
                                    <td className={'w-[15%]'}>{bo?.nature}</td>
                                    <td className={'w-[15%]'}>{bo?.neighborhood}</td>
                                    <td className={'w-[10%]'}>
                                        <span className={!tags?.length ? "text-[#8F8F8F] italic" : ""}>
                                            {tags.length ? tags.join(', ') : "Não informado"}
                                        </span>
                                    </td>
                                    <td className={'w-[40%%]'}>{bo?.observation}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default BoContent;
